/**
 * Композиция валидаторов, можно объединить несколько валидаторов в один
 * @example composeValidators(required, email)(value)
 * @param validators
 * @returns {function(*=): (*)}
 */
const compose = (...validators) => (...args) =>
  validators.reduce(
    (error, validator) => error || validator(...args),
    undefined
  );

export default compose;
